import { render, staticRenderFns } from "./gameTips.vue?vue&type=template&id=69048f22&scoped=true&"
import script from "./gameTips.vue?vue&type=script&lang=js&"
export * from "./gameTips.vue?vue&type=script&lang=js&"
import style0 from "./gameTips.vue?vue&type=style&index=0&id=69048f22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69048f22",
  null
  
)

export default component.exports